<form #beneficiaryForm="ngForm" [attr.data-test-id]="testId + '.form'">
    <div *ngIf="loading" class="d-flex align-items-center justify-content-center">
        <mat-spinner [diameter]="50" color="accent" mode="indeterminate"></mat-spinner>
    </div>
    <div class="m-form__group" *ngIf="!loading">
        <ng-container *ngFor="let beneficiaryApplicant of beneficiaryApplicants; let i = index">
            <ng-container *ngIf="i > 0">
                <div class="row">
                    <div class="col-auto mb-32 mt-32" *ngIf="!beneficiaryApplicant.applicantId">
                        <a matTooltip="Delete" mat-flat-button (click)="removeAdditionalBeneficiary(i)"
                            [attr.data-test-id]="testId + '.remove-button.' + i">
                            <sm-icon name="trash" [width]="24" [height]="24"></sm-icon>
                        </a>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <!-- +2 because array start from 0 and one beneficiary already displayed above-->
                        <h2 class="section-title" [attr.data-test-id]="testId + '.additional-title.' + i"> Additional Beneficiary - {{ i }}
                        </h2>
                    </div>
                </div>
            </ng-container>
            <div class="row">
                    <div [class]="cssWidthClass" *ngIf="!appConfig.survivorshipBeneficiaryFields || appConfig.survivorshipBeneficiaryFields?.relationship !== false">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label [attr.data-test-id]="testId + '.relationship-label.' + i"> Relationship to primary applicant</mat-label>
                        <mat-select [(ngModel)]="beneficiaryApplicant.relationShipToPrimaryApplicant" required
                                    [name]="'relationShipToFamilyMember'+i" [id]="'relationShipToFamilyMember'+i"
                                    [attr.data-test-id]="testId + '.relationship-select.' + i">
                            <mat-option *ngFor="let type of beneficiaryType" [value]="type"
                                        [attr.data-test-id]="testId + '.relationship-option.' + i + '.' + type?.toLowerCase()">{{ type }}</mat-option>
                        </mat-select>
                        <mat-error [attr.data-test-id]="testId + '.relationship.required-error.' + i">Please select your relationship to the applicant.</mat-error>
                    </mat-form-field>
                </div>
                <div [class]="cssWidthClass">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label [attr.data-test-id]="testId + '.first-name-label.' + i">First Name</mat-label>
                        <input matInput type="text" alphabetWithSpace name="beneficiaryFirstName{{i}}"
                                [(ngModel)]="beneficiaryApplicant.firstName"
                                #beneficiaryFirstName="ngModel" required autocomplete="given-name"
                                [attr.data-test-id]="testId + '.first-name-input.' + i">
                        <mat-error [attr.data-test-id]="testId + '.first-name.required-error.' + i">Please enter the first name.</mat-error>
                    </mat-form-field>
                </div>
                <div [class]="cssWidthClass" *ngIf="appConfig.showMiddleName">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label [attr.data-test-id]="testId + '.middle-name-label.' + i">Middle Name</mat-label>
                        <input matInput type="text" alphabetWithSpace name="beneficiaryMiddleName{{i}}"
                                [(ngModel)]="beneficiaryApplicant.middleName"
                                #beneficiaryMiddleName="ngModel" autocomplete="additional-name"
                                [attr.data-test-id]="testId + '.middle-name-input.' + i">
                        <mat-error [attr.data-test-id]="testId + '.middle-name.required-error.' + i">Please enter the middle name.</mat-error>
                    </mat-form-field>
                </div>
                <div [class]="cssWidthClass">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label [attr.data-test-id]="testId + '.last-name-label.' + i">Last Name</mat-label>
                        <input matInput type="text" name="beneficiaryLastName{{i}}"
                                [(ngModel)]="beneficiaryApplicant.lastName"
                                #beneficiaryLastName="ngModel" required
                                alphabetWithSpace autocomplete="family-name"
                                [attr.data-test-id]="testId + '.last-name-input.' + i">
                        <mat-error [attr.data-test-id]="testId + '.last-name.required-error.' + i">Please enter the last name.</mat-error>
                    </mat-form-field>
                </div>

                <div [class]="cssWidthClass" *ngIf="!appConfig.survivorshipBeneficiaryFields || appConfig.survivorshipBeneficiaryFields?.dob">
                    <creditsnap-date [(ngModel)]="beneficiaryApplicant.dob" name="dateOfBirthBeneficiary{{i}}"
                                        [maxDate]="maxDobDate" #dob
                                        [minDate]="minDobDate"
                                        [attr.data-test-id]="testId + '.date-of-birth.' + i"></creditsnap-date>
                </div>

                <div [class]="cssWidthClass" *ngIf="!appConfig.survivorshipBeneficiaryFields || appConfig.survivorshipBeneficiaryFields?.ssn">

                    <creditsnap-ssn [(ngModel)]="beneficiaryApplicant.ssn" #ssn
                                    [name]="'beneficiarySSN'+i" [id]="'beneficiarySSN'+i"
                                        [required]="appConfig.survivorshipBeneficiaryFields?.ssnRequired !== false"
                                    [attr.data-test-id]="testId + '.ssn.' + i"
                    ></creditsnap-ssn>
                </div>
                <div [class]="cssWidthClass" *ngIf="!appConfig.survivorshipBeneficiaryFields || appConfig.survivorshipBeneficiaryFields?.phone">
                    <creditsnap-phone-number #phone [(ngModel)]="beneficiaryApplicant.primaryPhone"
                                             [label]="'Mobile Number'"
                                             [name]="'beneficiaryPhone'+i"
                                             [id]="'beneficiary-phone-number'+i"
                                             [attr.data-test-id]="testId + '.phone-number.' + i"></creditsnap-phone-number>
                </div>
                <ng-container *ngIf="!appConfig.survivorshipBeneficiaryFields || appConfig.survivorshipBeneficiaryFields?.address">
                    <div class="col-sm-12">
                        <creditsnap-address id="beneficiaryApplicantAddress{{i}}" #address
                                            [(ngModel)]="beneficiaryApplicant.address"
                                            name="beneficiaryApplicantAddress{{i}}"
                                            [attr.data-test-id]="testId + '.address.' + i"></creditsnap-address>
                    </div>
                </ng-container>
                <ng-container *ngIf="!appConfig.survivorshipBeneficiaryFields || appConfig.survivorshipBeneficiaryFields?.email">
                    <div class="col-sm-12">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-label [attr.data-test-id]="testId + '.email-label.' + i">E-mail</mat-label>
                            <input matInput [name]="'email'+i"
                                   autocomplete="off" [(ngModel)]="beneficiaryApplicant.email" #email="ngModel" min-max
                                   required [attr.data-test-id]="testId + '.email-input.' + i">
                            <mat-error *ngIf="email.hasError('required')" [attr.data-test-id]="testId + '.email.required-error.' + i">Please enter an email address.
                            </mat-error>
                            <mat-error *ngIf="email.hasError('email')" [attr.data-test-id]="testId + '.email.invalid-error.' + i">Please enter a valid email address.
                            </mat-error>
                        </mat-form-field>
                    </div>
                </ng-container>
                <div [class]="cssWidthClass" *ngIf="appConfig?.percentageOfBenefit">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label [attr.data-test-id]="testId + '.percentage-label.' + i">Percentage of Benefit</mat-label>
                        <input matInput type="number" name="beneficiaryPercentage{{i}}"
                               [(ngModel)]="beneficiaryApplicant.percentageOwnership" (ngModelChange)="updatePercentageOfBenefit()"
                               #beneficiaryPercentage="ngModel" required min="0" max="100"
                               [readonly]="beneficiaryApplicants.length === maxBeneficiary && i === beneficiaryApplicants.length - 1"
                               [attr.data-test-id]="testId + '.percentage-input.' + i">
                        <mat-error [attr.data-test-id]="testId + '.percentage.min-max-error.' + i">Please enter a percentage between 0 and 100.</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>
        <div class="row mt-32" *ngIf="beneficiaryApplicants.length < maxBeneficiary && percentageOfBenefit < 100">
            <div class="col-md-12">
                <button (click)="addAdditionalBeneficiary()"
                        type="button"
                        class="cs-link p-0 btn"
                        matTooltip="Add Additional Beneficiary"
                        [attr.data-test-id]="testId + '.add-beneficiary-button'">
                    Add Additional Beneficiary
                </button>
            </div>
        </div>
        <div class="row mt-3" *ngIf="appConfig?.percentageOfBenefit && percentageError">
            <div class="col-md-12">
                <div class="text-danger text-sm-center text-start" [attr.data-test-id]="testId + '.percentage-total-error-text'">
                    Total percentage of benefit must equal exactly 100%
                </div>
            </div>
        </div>
    </div>

</form>
